import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getGrupoFisicoPluviometroList } from './selectdbAtions';
import { getConfig, setConfig } from '../../configuracao/configLocal';
import { getConfControladorGrupoPluviometroList } from './selectdbAtions';

import './contentHeaderFilter.css';

class SelectConfGrupoFisicoPluviometro extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: getConfig('grupo'),
    };
  }

  componentDidMount() {
    this.props.getGrupoFisicoPluviometroList();
  }

  renderOptions() {
    const list = this.props.listPluviometro || [];

    if (list.length === 0) {
      return <option value="">Carregando...</option>;
    }

    return list.map(grupo => (
      <option key={grupo.id} value={grupo.id}>
        {grupo.id} - {grupo.descricao}
      </option>
    ));
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
    setConfig('grupo', event.target.value);
    setConfig('cont', 0);
    setConfig('numCont', 0);
    setConfig('anel', 0);
    this.props.getConfControladorGrupoPluviometroList();
    if (this.props.onChange) {
      this.props.onChange(event.target.value);
    }
  }

  render() {
    const defaultStyle = { width: '160px', display: 'inline' };
    const finalStyle = this.props.customStyle ? this.props.customStyle : defaultStyle;

    return (
      <div style={{ marginTop: '0px' }}>
        {!this.props.customStyle && (
          <label
            style={{ fontSize: '14px !important', color: '#333', fontWeight: 'normal', margin: 0 }}
            htmlFor={'selectGrupoFisico'}
          >
            <small>Grupo Físico: </small>
          </label>
        )}
        <select
          id={'selectGrupoFisico'}
          name={'selectGrupoFisico'}
          style={finalStyle}
          className={this.props.customStyle ? '' : 'form-control'}
          onChange={event => {
            this.handleChange(event);
          }}
          value={this.state.value}
        >
          <option value="">{this.props.emptyText || 'Selecione...'}</option>
          {this.renderOptions()}
        </select>
      </div>
    );
  }
}

const mapStateToProps = state => ({ listPluviometro: state.selectdb.listGrupoFisicoPluviometro });
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getGrupoFisicoPluviometroList,
      getConfControladorGrupoPluviometroList,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectConfGrupoFisicoPluviometro);
